import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { Navigate } from 'react-router-dom';
import '../styles/Profile.css';

const OrderHistory = () => {
  const { user } = useAuth();
  const { orders, loadUserOrders } = useCart();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      console.log('OrderHistory: Loading orders for user:', user.email);
      setLoading(true);
      loadUserOrders(user.email).finally(() => {
        setLoading(false);
      });
    }
  }, [user, loadUserOrders]);

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (loading) {
    return (
      <div className="profile">
        <div className="profile-card">
          <h1>Order History</h1>
          <p>Loading orders...</p>
        </div>
      </div>
    );
  }

  const handleRefresh = async () => {
    if (user) {
      setLoading(true);
      await loadUserOrders(user.email);
      setLoading(false);
    }
  };

  const handleDebugAllOrders = async () => {
    try {
      const { getAllOrders } = await import('../firebase/services');
      const allOrders = await getAllOrders();
      console.log('All orders in database:', allOrders);
      alert(`Found ${allOrders.length} total orders in database. Check console for details.`);
    } catch (error) {
      console.error('Error getting all orders:', error);
    }
  };

  console.log('OrderHistory: Rendering with orders:', orders);

  return (
    <div className="profile">
      <div className="profile-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h1>Order History</h1>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button onClick={handleRefresh} disabled={loading} className="btn-refresh">
              {loading ? 'Loading...' : 'Refresh'}
            </button>
            <button onClick={handleDebugAllOrders} className="btn-refresh">
              Debug All Orders
            </button>
          </div>
        </div>
        {orders.length === 0 ? (
          <div>
            <p>No orders yet</p>
            <p><small>Debug: User email: {user.email}</small></p>
          </div>
        ) : (
          <div className="orders-list">
            {orders.map(order => (
              <div key={order.id} className="order-item">
                {/* Header Section */}
                <div className="order-header">
                  <span>Order #{order.id.slice(-8)}</span>
                  <span className="order-status">{order.status}</span>
                </div>
                
                <p className="order-date">
                  {order.createdAt ? new Date(order.createdAt.seconds * 1000).toLocaleDateString('en-IN', { 
                    day: 'numeric', 
                    month: 'long', 
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  }) : 'Date not available'}
                </p>
                
                {/* Items Section */}
                <div className="order-section">
                  <h4 className="section-title">📦 Order Items</h4>
                  <div className="order-items">
                    {order.items.map((item, index) => (
                      <div key={index} className="order-product">
                        <div className="product-info">
                          <span className="product-name">
                            {item.displayName || item.name}
                            {item.variant && <span className="product-variant"> ({item.variant.name})</span>}
                          </span>
                          <span className="product-quantity">Qty: {item.quantity}</span>
                        </div>
                        <span className="product-price">₹{(item.price * item.quantity).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Total Price */}
                <div className="order-total-simple">
                  <span>Total Amount</span>
                  <span className="total-amount">₹{order.total.toFixed(2)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderHistory;
